export type MarketingSourceKey = 'email' | 'website' | 'property' | 'phone'

export type MarketingStageKey =
    | 'leads'
    | 'app_sent'
    | 'screening'
    | 'leases'
    | 'future_resident'

export type MarketingStageCounts = Record<MarketingStageKey, number>

export interface MarketingSourceRow {
    key: MarketingSourceKey
    total: number
    converted: number
    stages: MarketingStageCounts
}

export interface MarketingCampaignRow {
    id: number
    name: string
    status: string
    total: number
    converted: number
    stages: MarketingStageCounts
}

export interface MarketingChannelsResponse {
    total: number
    converted: number
    sources: MarketingSourceRow[]
    campaigns: MarketingCampaignRow[]
}

export const MARKETING_SOURCE_LABEL: Record<MarketingSourceKey, string> = {
    email: 'Campaign',
    website: 'Website',
    property: 'Walk-in',
    phone: 'Phone',
}

export const MARKETING_SOURCE_COLOR: Record<MarketingSourceKey, string> = {
    email: '#7c3aed',
    website: '#6570E6',
    property: '#d97706',
    phone: '#0d9488',
}

export const MARKETING_STAGE_COLUMNS: {
    key: MarketingStageKey
    label: string
    color: string
}[] = [
    { key: 'leads', label: 'Leads', color: '#64748b' },
    { key: 'app_sent', label: 'Applications', color: '#3b82f6' },
    { key: 'screening', label: 'Screening', color: '#8b5cf6' },
    { key: 'leases', label: 'Leases', color: '#f59e0b' },
    { key: 'future_resident', label: 'Future resident', color: '#16a34a' },
]
